import React from 'react';
import profileImage from '../images/profile.jpg'; // Specify the path to your profile picture
export const Profile = (props) => {
    return (
      <div className="profile-card">
        <img src={profileImage} alt="Profile" className="profile-image" />
        <div className="profile-details">
          <h2 className="profile-title">Profile</h2>
          <p className="profile-info"><strong>Name:</strong> {props.name}</p>
          <p className="profile-info"><strong>Email:</strong> {props.email}</p>
        </div>
      </div>
    );
};